module.exports = __webpack_public_path__ + "static/wl-dracula-theme-6b8f2d02a3d6d0771216045f79044b1b.png";